import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { UserService } from './user.service';
import { Roles } from '../layouts/full/shared/Enums';



const BASE_URL = environment.base_url;
const base_url = environment.base_url_second;

const PRO_BASIC_SUBSCRIPTION = environment.stripeSubscriptions.distributor.basic;
const PRO_ADVANCED_SUBSCRIPTION = environment.stripeSubscriptions.distributor.advanced;
const PRO_PRO_SUBSCRIPTION = environment.stripeSubscriptions.distributor.pro;
const PRO_3D_DESIGN_INSOLES_SUBSCRIPTION = environment.stripeSubscriptions.distributor.three_d_design_insoles;

const CLIENT_BASIC_SUBSCRIPTION = environment.stripeSubscriptions.client.basic;
const CLIENT_ADVANCED_SUBSCRIPTION = environment.stripeSubscriptions.client.advanced;
const CLIENT_PRO_SUBSCRIPTION = environment.stripeSubscriptions.client.pro;
const CLIENT_3D_DESIGN_INSOLES_SUBSCRIPTION = environment.stripeSubscriptions.client.three_d_design_insoles;

const THREE_D_DESIGN_AFO_SUBSCRIPTION = environment.stripeSubscriptions.distributor.three_d_design_afo
const THREE_D_DESIGN_SPINAL_BRACE_SUBSCRIPTION = environment.stripeSubscriptions.distributor.three_d_design_spinal_brace

@Injectable({
    providedIn: 'root'
})
export class StripeService {

    constructor(
        private http: HttpClient,
        public userService: UserService,
    ) { }

    charge(productId: string, tokenId: string) {
        return this.http.post(`${BASE_URL}/checkout`, {
            productId,
            tokenId
        }).toPromise()
    }

    subscribe(productId: string, tokenId: string) {
        let servicesToSubscribe: { name: string, productId: string }[] = []

        servicesToSubscribe.push(
            {
                name: 'Basic scans',
                productId: this.userService.user.role === Roles.ROLE_DISTRIBUTOR ? PRO_BASIC_SUBSCRIPTION : CLIENT_BASIC_SUBSCRIPTION
            },
            {
                name: 'Advanced scans',
                productId: this.userService.user.role === Roles.ROLE_DISTRIBUTOR ? PRO_ADVANCED_SUBSCRIPTION : CLIENT_ADVANCED_SUBSCRIPTION
            }
            , {
                name: 'Pro scans',
                productId: this.userService.user.role === Roles.ROLE_DISTRIBUTOR ? PRO_PRO_SUBSCRIPTION : CLIENT_PRO_SUBSCRIPTION
            },
            {
                name: '3D design insoles',
                productId: this.userService.user.role === Roles.ROLE_DISTRIBUTOR ? PRO_3D_DESIGN_INSOLES_SUBSCRIPTION : CLIENT_3D_DESIGN_INSOLES_SUBSCRIPTION
            },
            {
                name: '3D design afo',
                productId: THREE_D_DESIGN_AFO_SUBSCRIPTION
            },
            {
                name: '3D design spinal brace',
                productId: THREE_D_DESIGN_SPINAL_BRACE_SUBSCRIPTION
            }
        )

        const token = localStorage.getItem('token') || '';
        const headers = {
            'X-Amz-Security-Token': token
        }

        return this.http.post(`${BASE_URL}/subscriptions`, {
            productId,
            tokenId,
            services: servicesToSubscribe
        }, { headers })
            .pipe(
                catchError(this.handleError)
            )
    }

    handleError(error: any) {

        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }

        // console.log(errorMessage);
        return throwError(error);
    }

    getPaymentLink(data: any) {
        return this.http.post(`${base_url}/paymentLink`, data);
    }
}
